import React from 'react';
import { Radio, Space } from 'antd';

const ListState = ({ stateIndex, stateList, height, onStateChange }) => {
    return (
        <div className='stateListDiv' style={{ display: 'flex', flexDirection: 'column',
        maxHeight: height-200, overflow: 'auto' }}>
            <Radio.Group className='stateBtn' onChange={onStateChange} value={stateIndex}
            optionType="button" buttonStyle="solid">
                <Space className='stateBtn' direction="vertical">
                    {stateList.map((item, index) => (
                        <Radio className='stateBtn' key={index} value={index}>
                            {item.name+''+(item.lName ? ' '+item.lName : '')}
                        </Radio>
                    ))}
                </Space>
            </Radio.Group>
        </div>
    );
}

export default ListState;